import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'UserCard' })((theme) => ({
  root: {
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    maxWidth: '100%',
    borderRadius: theme.shape.borderRadius,
  },
  rootContained: {
    width: 'fit-content',
  },
  rootFullWidth: {
    width: '100%',
  },

  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    minWidth: 0,
  },

  avatarContainer: {
    flexShrink: 0,
    lineHeight: 0,
  },

  userMeta: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    flex: 1,
    minWidth: 0,
  },

  userMetaText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    alignItems: 'flex-start',
  },
}));
